import { render, staticRenderFns } from "./Faq.vue?vue&type=template&id=b8729d22&scoped=true&lang=html"
import script from "./Faq.vue?vue&type=script&lang=js"
export * from "./Faq.vue?vue&type=script&lang=js"
import style0 from "./Faq.vue?vue&type=style&index=0&id=b8729d22&prod&lang=css"
import style1 from "./Faq.vue?vue&type=style&index=1&id=b8729d22&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8729d22",
  null
  
)

export default component.exports